import { http as axios } from "./axios";

class UserService {
  delete(user) {
    return axios.delete(`users/${user.id}`);
  }
  list() {
    return axios.get(`users`);
  }

  updateNotifications(user) {
    const { newsletter } = user;

    return axios.put(`users/${user.id}`, { newsletter });
  }

  updateProfile(user) {
    delete user["false"];
    delete user["true"];

    // eslint-disable-next-line no-unused-vars
    const { newsletter, password, avatar, ...rest } = user;

    return axios.put(`users/${user.id}`, rest);
  }

  updateAvatar(user) {
    // save image
    if (user.avatar) {
      let formData = new FormData();
      formData.append("file", user.avatar);

      return axios.put(`users/${user.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }

    // delete image
    return axios.put(`users/${user.id}`, { avatar: null });
  }

  async confirmNewsletter(user) {
    return axios.put("users/newsletter_subscribe", user);
  }

  deleteAccount(user) {
    const { id } = user;

    return axios.delete(`users/${id}`);
  }
}

export default new UserService();
